const FormatSocial = value => {

    // return nothing if no value
    if (!value) return value;

    // only allows 0-9 inputs
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;

    // returns: "x", "xx", "xxx"
    if (cvLength < 4) return currentValue;

    // returns: "xxx", "xxx-x", "xxx-xx", "xxx-xx",
    if (cvLength < 6) return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;

    // returns: "xxx-xx-", xxx-xx-x", "xxx-xx-xx", "xxx-xx-xxx", "xxx-xx-xxxx"
    return `${currentValue.slice(0, 3)}-${currentValue.slice(3, 5)}-${currentValue.slice(5, 9)}`;
}

const FormatEIN = value => {

    // return nothing if no value
    if (!value) return value;

    // only allows 0-9 inputs
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;

    // returns: "x", "xx"
    if (cvLength < 3) return currentValue;

    // returns: "xx-xxxxxxx",
    return `${currentValue.slice(0, 2)}-${currentValue.slice(2, 9)}`;
}

const FormatSocialLastFour = value => {

    // return nothing if no value
    if (!value) return value;

    // only allows 0-9 inputs
    const currentValue = value.replace(/[^\d]/g, '');

    if (currentValue == "") return currentValue;

    const cvLength = currentValue.length;

    // returns: "xxxx",
    return "XXX-XX-"+currentValue.slice(0, 4);
}

export {
    FormatSocial,
    FormatEIN,
    FormatSocialLastFour
}
